import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        let dateFormat = webix.Date.dateToStr('%d-%m-%Y %H:%i:%s'); // Date format for display
        const cur_user = this.getParam('user', true); // Get current user parameter

        // Custom data filter for summing column values
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    var size = $$('datatable').getPager().config.size; // Get page size
                    var page = $$('datatable').getPage(); // Get current page
                    var first = size * page; // Calculate first item index
                    var last = first + size - 1; // Calculate last item index
                    var count = 0; // Initialize count

                    // Iterate through master data to calculate sum
                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Sum the values
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summation column filter
        );

        // Return the layout configuration
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // Unique ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: document.body.offsetWidth < 500 ? 0 : 400, // Set height based on screen width
                            columns: [
                                // Define columns for the DataTable
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    minWidth: 90, // Column width
                                    adjust: 'data', // Width adjusts to content
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID
                                    header: _('ID Usuario'), // Localized column header
                                    minWidth: 90, // Column width
                                    adjust: 'data', // Width adjusts to content
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocal', // Column ID
                                    header: _('Fecha de creación'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'Provider', // Column ID
                                    header: _('Proveedor'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PaymentSystemName', // Column ID
                                    header: _('Nombre Sistema Pasarela Pago'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeName', // Column ID
                                    header: _('Tipo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CurrencyId', // Column ID
                                    header: _('Moneda'), // Localized column header
                                    width: 70, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                    editor: 'text', // Editor type
                                },
                                {
                                    id: 'ModifiedLocal', // Column ID
                                    header: _('Modificado'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    options: [
                                        // Options for dropdown
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Pagada') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivo') },
                                        { id: 'R', value: _('Rechazada') },
                                    ],
                                },
                                {
                                    id: 'ExternalId', // Column ID
                                    header: _('External ID'), // Localized column header
                                    minWidth: 90, // Column width
                                    adjust: 'data', // Width adjusts to content
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ip', // Column ID
                                    header: 'IP', // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for detail icon click
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('deposit:id', [
                                        item.Id, // Call event with item ID
                                    ]);
                                    // Show details based on screen size
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show(); // Show filter details
                                    } else {
                                        $$('dColl').expand(); // Expand details
                                    }
                                },
                            },
                            on: {
                                // Event handler for before loading data
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                // Event handler for after loading data
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                    // Recalculate ID column widths
                                    this.adjustColumn('Id', 'data');
                                    this.adjustColumn('ClientId', 'data');
                                    this.adjustColumn('ExternalId', 'data');
                                },
                            },
                            // Event handler for when the grid is ready
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead option
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'es/Financial/GetDepositsWithdrawalsWithPaging2?PlayerId=' + cur_user + '&'; // API URL for fetching data
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'depositReportPlayer:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            // Iterate through filter data to build query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Add PlayerId to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + user, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
